export enum AppInsightsEvent {
	ReadyEvent = "ready_event",
	ResultEvent = "result_event",
	RedirectEvent = "redirect_event",
	StripeEvent = "stripe_event",
	SubmittedStripeForm = "submitted_stripe_form",
	SubmittedStripeFormFailed = "submitted_stripe_form_failed",
}
